module.exports = __webpack_public_path__ + "img/IE.22b42065.svg";